import { buildDemoHtmlAppPayload } from './generatedArtifactDemoHtmlPayload.js'

/** @typedef {import('@/features/documentPreview/documentPreviewTypes.js').ArtifactKind} ArtifactKind */

export function buildDemoDocPayload(title) {
  return {
    sections: [
      { type: 'heading', text: title, level: 1 },
      { type: 'paragraph', text: 'Generated by SIA. Continue the conversation to refine this draft.' },
      { type: 'heading', text: 'Executive summary', level: 2 },
      { type: 'paragraph', text: 'Key themes synthesized for stakeholders. Replace with live model output when connected.' },
      { type: 'heading', text: 'Next steps', level: 2 },
      { type: 'paragraph', text: 'Review, add data, and share with your team.' },
    ],
  }
}

export function buildDemoSpreadsheetPayload() {
  return {
    columns: ['Task', 'Owner', 'Status', 'Due'],
    rows: [
      { Task: 'Scope requirements', Owner: 'SIA', Status: 'Done', Due: 'May 12' },
      { Task: 'Draft data model', Owner: 'Design', Status: 'In progress', Due: 'May 18' },
      { Task: 'Build preview panel', Owner: 'Eng', Status: 'In progress', Due: 'May 21' },
      { Task: 'User testing', Owner: 'Product', Status: 'Planned', Due: 'May 28' },
      { Task: 'Launch checklist', Owner: 'Ops', Status: 'Planned', Due: 'Jun 02' },
    ],
  }
}

export function buildDemoPayloadForKind(kind, title) {
  if (kind === 'spreadsheet') return buildDemoSpreadsheetPayload()
  if (kind === 'html') return buildDemoHtmlAppPayload(title)
  return buildDemoDocPayload(title)
}
